// 协议
export default [{ // 服务协议
  path: '/serviceAgreement',
  name: 'serviceAgreement',
  component: resolve => require(['@/views/agreement/serviceAgreement.vue'], resolve),
  meta: {}
}, { // 隐私协议
  path: '/privacyAgreement',
  name: 'privacyAgreement',
  component: resolve => require(['@/views/agreement/privacyAgreement.vue'], resolve),
  meta: {}
}, { // 儿童隐私协议
  path: '/childProtection',
  name: 'childProtection',
  component: resolve => require(['@/views/agreement/childProtection.vue'], resolve),
  meta: {}
}]


// WEBPACK FOOTER //
// ./src/router/agreement/agreement.js